import dayjs, { Dayjs } from 'dayjs'

import { DEFAULT_TIMEZONE } from '@/components/entities/requests/model/constants'

export const MIN_MINUTES_TO_BOOK_CURRENT_HOUR = 10

export const isCurrentHourExpired = (now: Date | string | number): boolean => {
  const mskNow = dayjs(now).tz(DEFAULT_TIMEZONE)

  const minutesLeftInCurrentHour = mskNow
    .startOf('hour')
    .add(1, 'hour')
    .diff(mskNow, 'minute', true)

  return minutesLeftInCurrentHour <= MIN_MINUTES_TO_BOOK_CURRENT_HOUR
}

export const getFirstBookableHour = (now: Date | string | number): Dayjs => {
  const currentHour = dayjs(now).tz(DEFAULT_TIMEZONE).startOf('hour')

  return isCurrentHourExpired(now) ? currentHour.add(1, 'hour') : currentHour
}
